var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a name=\"reservation-part-{{$ctrl.phase}}\" id=\"reservation-part-{{$ctrl.phase}}\"> </a> <web-component ng-show=\"$ctrl.winresReservationContext.getCurrentPhase() == $ctrl.phase\"> <div class=\"web-component-bg\"> <div class=\"web-component-center\"> <ng-transclude></ng-transclude> </div> </div> </web-component>";
var id1="winresReservationCustomPhase.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationCustomPhase/winresReservationCustomPhase.html
// module id = 394
// module chunks = 2